import "./App.css";
import Header from './Header.js';
import Body from './Body.js';

function App() {
  return (
    <div>
      <Header/>
      <Body/>
    </div>
  );
}


export default App;